export default __webpack_public_path__ + "static/media/sad_face_no_shadow.90009632.svg";